import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
import axios from './axios';

export default {
  create: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, data) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.post('/domain/' + type + '/create', data);

            case 2:
              return _context.abrupt('return', _context.sent.data);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return create;
  }(),
  createUser: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios.post('http://localhost:3003/domain/User/create', data);

            case 2:
              return _context2.abrupt('return', _context2.sent.data);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function createUser(_x3) {
      return _ref2.apply(this, arguments);
    }

    return createUser;
  }(),

  // @example
  // let user = domain.get('User',id);
  // user('changeName')(name);
  get: function get(type, id) {
    var _this = this;

    return function (method) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return axios.post('/domain/' + type + '/' + id + '/' + method, args);

              case 2:
                return _context3.abrupt('return', _context3.sent.data);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./plugins/domain.js
// module id = ./plugins/domain.js
// module chunks = 0 1 2 4 5 6 7 8